import { Directive, ElementRef, inject, InjectionToken, Renderer2 } from '@angular/core';

/**
 * Injection token that can be used to reference instances of `KrosError`. It serves as
 * alternative token to the actual `KrosError` class which could cause unnecessary
 * retention of the class and its directive metadata.
 */
export const KROS_INPUT_ERROR = new InjectionToken<KrosInputError>('KrosInputError');

let nextUniqueId = 0;

/** Single error message to be shown underneath the form-field. */
@Directive({
  selector: 'kros-input-error, [krosInputError]',
  host: {
    class: 'kros-form-field-error',
  },
  providers: [{ provide: KROS_INPUT_ERROR, useExisting: KrosInputError }],
  standalone: false,
})
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export class KrosInputError {
  readonly nativeElement = inject(ElementRef).nativeElement;
  readonly #renderer = inject(Renderer2);

  readonly attributeId = `kros-form-field-error-${nextUniqueId++}`;

  constructor() {
    this.#renderer.setAttribute(this.nativeElement, 'id', this.attributeId);
  }
}
